<script>
  import { router } from '@inertiajs/svelte';
  
  let { security_key = {}, confirmation = false } = $props();
  
  let name = $state(security_key.name || '');
  
  function updateSecurityKey(event) {
    event.preventDefault();
    router.patch(`/two_factor_authentication/profile/security_keys/${security_key.id}`, {
      name
    });
  }
  
  function removeSecurityKey() {
    if (confirm(`Are you sure you want to remove this security key (${security_key.name})?`)) {
      router.delete(`/two_factor_authentication/profile/security_keys/${security_key.id}`);
    }
  }
</script>

<div class="edit-security-key-container">
  <h1>Edit security key</h1>
  
  {#if confirmation}
    <!-- Confirmation form for newly created security key -->
    <form onsubmit={updateSecurityKey}>
      <p>One more step. Please give this security key a nickname to help you remember it.</p>
      
      <div class="form-group">
        <label for="name" class="form-label">Name</label>
        <!-- svelte-ignore a11y_autofocus -->
        <input 
          id="name" 
          type="text" 
          bind:value={name} 
          required 
          autofocus 
          class="form-input"
        />
        <div class="form-hint">e.g., Macbook Touch ID</div>
      </div>
      
      <div class="form-actions">
        <button type="submit" class="save-button">Save</button>
      </div>
    </form>
  {:else}
    <!-- Edit form for existing security key -->
    <form onsubmit={updateSecurityKey}>
      <div class="form-group">
        <label for="name" class="form-label">Name</label>
        <!-- svelte-ignore a11y_autofocus -->
        <input 
          id="name" 
          type="text" 
          bind:value={name} 
          required 
          autofocus 
          class="form-input"
        />
        <div class="form-hint">e.g., Macbook Touch ID</div>
      </div>
      
      <div class="form-actions">
        <button type="submit" class="save-button">Save changes</button>
      </div>
    </form>
    
    <div class="delete-section">
      <button type="button" class="delete-button" onclick={removeSecurityKey}>
        Remove this security key...
      </button>
    </div>
  {/if}
</div>

<style>
  .edit-security-key-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    max-width: 300px;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-hint {
    font-size: 0.875rem;
    color: #6b7280;
    margin-top: 0.25rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .save-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .save-button:hover {
    background-color: #065f46;
  }
  
  .delete-section {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e7eb;
  }
  
  .delete-button {
    background-color: #ef4444;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .delete-button:hover {
    background-color: #dc2626;
  }
</style>